import "core-js/modules/es.array.push.js";
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-e781b63a"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "buy-page-root page-bottom-padding-height scroll-bar-style"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "buy-top-bg-box"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "buy-top-bg-img",
  src: "https://summit-img.geekpark.net/if2023/buy_tickek_top_bg.jpg"
})], -1));

const _hoisted_3 = {
  class: "tip-text"
};
const _hoisted_4 = {
  class: "ticket-list-box"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "left-part"
};
const _hoisted_7 = {
  class: "price-box"
};

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "color-block color-block-1"
}, null, -1));

const _hoisted_9 = {
  class: "price-text"
};
const _hoisted_10 = {
  class: "price-number"
};

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "price-tag"
}, "RMB", -1));

const _hoisted_12 = {
  class: "tickeks-title"
};
const _hoisted_13 = {
  class: "right-part"
};
const _hoisted_14 = ["src"];
const _hoisted_15 = {
  class: "buy-now"
};
const _hoisted_16 = ["onClick"];

const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "· 票品售出，除因不可抗力因素导致大会延期或取消，其他不支持退改", -1));

const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "· 核销需配合出示学生证/学生卡进行核验", -1));

const _hoisted_19 = [_hoisted_17, _hoisted_18];
const _hoisted_20 = {
  key: 0,
  class: "is-buied-student-btn-empty"
};
const _hoisted_21 = {
  key: 1,
  class: "is-buied-student-btn"
};
const _hoisted_22 = ["onClick"];
import { ref, onBeforeMount } from "vue";
import router from "../router";
import request from "../assets/utils/request";
import { nftShopApi } from "../common.config";
import { Toast } from "vant";
import TopNavigator from "../components/TopNavigator.vue";
export default {
  __name: 'BuyPageStudent',
  props: {},

  setup(__props) {
    const props = __props;
    onBeforeMount(() => {
      fetch();
    });
    const topTextTip = ref([]);
    const tickets = ref([]);

    const fetch = () => {
      Toast.loading({
        message: "加载中...",
        duration: 0,
        forbidClick: true
      });
      request.get(`${nftShopApi}/ticket_cat/info?ticket_cat_type=[2]`).then(res => {
        tickets.value = res.data;
        tickets.value.forEach((item, index) => {
          item.priceStr = Number(item.price) / 100;
          request.get(`${nftShopApi}/ticket_cat/buyed_stu_ticket?ticket_cat_id=${item.objectId}`).then(res => {
            if (res.data) {
              item.beBuiedStudent = true;
            } else {
              item.beBuiedStudent = false;
            }
          }).catch(err => {
            console.error("获取学生票购买状态err:", err);
          });
        }); // 正价票-1、学生票-2、早鸟票-3

        topTextTip.value = ["学生专享价格，每种票品限购一张~"];
        Toast.clear(true);
      }).catch(err => {
        Toast.fail("出错了");
        console.error("err:", err);
      });
    }; // 订单结算


    const handleToBuy = ticketInfo => {
      router.push(`/submit-order?productId=${ticketInfo.objectId}`);
    }; // 查看详情


    const handleToDetail = ticketInfo => {
      router.push(`/ticket-detail?productId=${ticketInfo.objectId}`);
    };

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(TopNavigator, {
        title: "学生专属购票"
      }), _createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topTextTip.value, tipText => {
        return _openBlock(), _createElementBlock("div", {
          class: "text-ticket",
          key: tipText
        }, _toDisplayString(tipText), 1);
      }), 128))]), _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tickets.value, ticketInfo => {
        return _openBlock(), _createElementBlock("div", {
          class: "ticket-item",
          key: ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.dateType
        }, [_createElementVNode("div", {
          class: "ticket-info",
          onClick: $event => handleToDetail(ticketInfo)
        }, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("div", _hoisted_9, [_createElementVNode("span", _hoisted_10, _toDisplayString(ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.priceStr), 1), _hoisted_11])]), _createElementVNode("div", _hoisted_12, _toDisplayString(ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.name) + "·极客公园创新大会2023", 1)]), _createElementVNode("div", _hoisted_13, [_createElementVNode("img", {
          class: "ticket-cover-img",
          src: ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.cover
        }, null, 8, _hoisted_14)])], 8, _hoisted_5), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", {
          class: "tickeks-tips",
          onClick: $event => handleToDetail(ticketInfo)
        }, _hoisted_19, 8, _hoisted_16), !(ticketInfo !== null && ticketInfo !== void 0 && ticketInfo.beBuiedStudent) && (ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.beBuiedStudent) !== false ? (_openBlock(), _createElementBlock("div", _hoisted_20)) : _createCommentVNode("", true), (ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.beBuiedStudent) === true ? (_openBlock(), _createElementBlock("div", _hoisted_21, "已购买过")) : _createCommentVNode("", true), (ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.beBuiedStudent) === false ? (_openBlock(), _createElementBlock("img", {
          key: 2,
          class: "buy-now-btn",
          src: "https://summit-img.geekpark.net/if2023/buy_now_btn.jpg",
          onClick: $event => handleToBuy(ticketInfo)
        }, null, 8, _hoisted_22)) : _createCommentVNode("", true)])]);
      }), 128))])])], 64);
    };
  }

};